<template>
  <main class="grid gap-3 py-4">
    <div v-if="!isBusinessBlock" class="w-full flex justify-center">
      <img src="../assets/business-doc-image.svg" />
    </div>
    <upload-bank-statement @toggleInstantVerification="CheckStatusOneMoney()" :profileBankDocCount = "profileBankDocCount" :toggleChangeBank="toggleChangeBank" :statusData="statusData"/>
    <section class="grid gap-3">
      <div class="flex flex-col items-start">
        <p class="label-text-medium">Business Registration Proof</p>
        <p v-if="!isBusinessBlock" class="secondary-heading-text">Only one document needed to start — two documents unlock extra benefits.</p>
      </div>
      <!-- <business-registeration-proof-upload v-if="!applicationSummary?.businessInfo?.gstin"/> -->
       <business-registeration-proof-upload v-if="isBusinessBlock" @business-document-select="handelDocumentSelect"/>
      <button v-if="!isBusinessBlock" @click.prevent="submitBusiness()" class="w-full py-1 rounded-xl bg-white border border-gray-100 shadow-lg">
        <div class="flex items-center justify-between py-2 gap-20">
          <!-- File Details Section -->
          <div class="flex items-center p-2">
            <span class="label-text-myriad px-2">Verify Your Business Document</span>
          </div>
        </div>
      </button>
    </section>
    <span class="grid pb-10"></span>
    <section class="footer z-10">
      <custom-button
        v-if="isBusinessBlock"
        @click.prevent="statusData.hasRequiredMonthsBankStatement === 'true' ? updateBusinessInfoStatus() : getBankStatementStatusNextBtn()"
        arrowAnimation
        :disabled="!isNextButtonDisabled"
        :variant="!isNextButtonDisabled ? 'disableGray' : 'primary'"
      >
        <p class="grid text-base">
          Next
        </p>
      </custom-button>
    </section>
    <router-view>
      <sidebar
        :isPanelOpen="isPanelOpen"
        @closeSidebarPanel="closeSideBar()"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section>
          <business-documents-list
            :businessDocumentSelectProps="businessDocumentSelect"
            @close-sidebar="closeSideBar"
            @is-business-block="isBusinessBlock = true"
          />
        </section>
      </sidebar>
    </router-view>
    <!-- Bank Statement under review -->
    <router-view>
      <sidebar
        :isPanelOpen="isPanelBankStatementUnderReview"
        @closeSidebarPanel="false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
          class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
        >
          <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <h2 class="heading-text">Bank statement</h2>
        </section>
        <div class="grid gap-4">
          <form @submit.prevent="getInstantVerification()">
            <section class="grid justify-items-center gap-6 py-4">
              <img class="w-40 h-40" src="../assets/double-bank-statement.svg" alt="doc img">
              <p class="label-text-normal text-center w-72">
                Bank statement review is in progress. Choose Instant Verification for quicker and improved loan offers.
              </p>
            </section>
            <section class="flex gap-4 py-8 px-4">
              <custom-button
                @click.prevent="updateBusinessInfoStatus()"
                type="submit"
                variant="transparentPrimary"
                class="w-full"
              >
                No
              </custom-button>
              <custom-button
                type="submit"
                variant="primary"
                class="w-full"
              >
                Yes
              </custom-button>
            </section>
          </form>
        </div>
      </sidebar>
    </router-view>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
    <!-- Spin Loan Offer Loader -->
    <spin-loader :dynamicMsg="true" :textSpinner="''" :subTextSpinner="textSpinnerText" :spinLoading="isSpinLoadingLoanOffer"/>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import Sidebar from '../components/Sidebar.vue';
import CustomButton from '../components/CustomButton.vue';
import SpinLoader from '../components/spinLoader.vue';
import BusinessRegisterationProofUpload from './BusinessRegisterationProofUpload.vue';
import UploadBankStatement from './UploadBankStatement.vue';
import BusinessDocumentsList from '../components/BusinessDocumentsList.vue';

export default {
  name: 'PreApprovalStep3',
  components: {
    Sidebar,
    CustomButton,
    SpinLoader,
    BusinessRegisterationProofUpload,
    UploadBankStatement,
    BusinessDocumentsList
  },
  computed: {
    ...mapGetters([
      'applicationId',
      'fetchDetails',
      'applicationSummary',
      'isBusinessRegistrationDocUploaded',
      'isBankStatementDocUploaded',
      'flagsData',
      'gstDataQuery',
      'applicationProfileData',
      'udyamDataPass',
      'videoKycScheduledDateTime'
    ]),
    isNextButtonDisabled() {
      const count = [
        this.isBusinessRegistrationDocUploaded,
        this.isBankStatementDocUploaded
      ].filter(Boolean).length;
      return count >= 2;
    }
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  watch: {
  },
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pageVisible: undefined,
      isPanelOpen: undefined,
      customPanelHeight: 'auto',
      isSpinLoading: undefined,
      isBusinessBlock: false,
      toggleChangeBank: undefined,
      documentTypes: [],
      businessDocumentSelect: undefined,
      params: {
        businessInfo: {
          name: undefined,
          businessType: undefined,
          businessCategory: undefined,
          address: {
            pincode: undefined,
            line1: undefined,
            city: undefined,
            state: undefined
          }
        }
      },
      profileBankDocCount: undefined,
      statusData: undefined,
      isSpinLoadingLoanOffer: undefined,
      textSpinnerText: "We’re processing your request",
      isPanelBankStatementUnderReview: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_VERFICATION_LANDED);
      if (localStorage.getItem('isBusinessBlock') || this.gstDataQuery?.length > 0 || this.udyamDataPass) {
        this.isBusinessBlock = true;
      } else {
        this.isBusinessBlock = false;
      }
      if (!this.applicationSummary) {
        this.getApplicationSummary();
      }
      this.getApplicationProfile();
    },
    closeSideBar() {
      this.isPanelOpen = false;
    },
    getApplicationProfile() {
      this.isSpinLoading = true;
      this.$store
        .dispatch('applicationProfile', {
          applicationId: this.applicationId
        })
        .then((result) => {
          const bankStatementProofs = result?.documents?.filter(
            (document) => document.docType === 'bank_statement' && document.docSubType === 'not_applicable'
          ) || undefined;
          this.getBankStatementStatus('profile_first');
          this.profileBankDocCount = bankStatementProofs?.length || 0;
          this.isSpinLoading = false;
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    getApplicationSummary() {
      this.isSpinLoading = true;
      this.$store
        .dispatch('applicationSummary', { applicationId: this.applicationId })
        .then(() => {
          this.isSpinLoading = false;
        })
        .catch(() => { this.isSpinLoading = false; });
    },
    updateBusinessInfoStatus() {
      this.isSpinLoading = true;
      this.params.businessInfo.name = this.applicationSummary?.businessInfo?.name;
      this.params.businessInfo.address.pincode = this.applicationSummary?.businessInfo?.address.pincode;
      this.params.businessInfo.address.line1 = this.applicationSummary?.businessInfo?.address.line1;
      this.params.businessInfo.address.city = this.applicationSummary?.businessInfo?.address.city;
      this.params.businessInfo.address.state = this.applicationSummary?.businessInfo?.address.state;
      this.$store
        .dispatch('v3ApplicationBusinessInfo', {
          applicationId: this.applicationId,
          patchParams: this.params,
          urlParams: {
            review: false,
          },
        })
        .then(() => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_INFO, {
            [this.$mixpanelPayload.RESPONSE]: 'success'
          });
          if (this.videoKycScheduledDateTime) {
            this.slotBooked();
          }
          this.isSpinLoading = false;
          this.isPanelBankStatementUnderReview = false;
          this.$router.push({
            name: 'Product Card'
          });
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_INFO, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message
          });
          this.isSpinLoading = false;
        });
    },
    submitBusiness() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_DOCUMENT_CLICKED);
      const summaryData = this.applicationSummary;
      if (summaryData?.businessInfo?.gstin ||
          summaryData?.businessInfo?.udyamDetails ||
          summaryData?.documentListUploaded?.fssaiUploaded ||
          summaryData?.documentListUploaded?.fdaUploaded ||
          summaryData?.documentListUploaded?.shopAndEstablishmentUploaded ||
          summaryData?.documentListUploaded?.othersUploaded) {
        this.isBusinessBlock = true;
      } else {
        this.isPanelOpen = true;
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.pageVisible = false;
      } else {
        this.pageVisible = true;
        this.getBankStatementStatusRetry();
      }
    },
    getBankStatementStatus(check) {
      this.isSpinLoading = true;
      this.$store
        .dispatch('bankStatementStatus', {
          applicationId: this.applicationId,
        })
        .then((res) => {
          if (check === 'profile_first') {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
              [this.$mixpanelPayload.RESPONSE]: res,
              [this.$mixpanelPayload.LANDING]: 'first time hit status api'
            });
            if (!res.bankStatementProcessed && res.hasRequiredMonthsBankStatement === "" && res.processingType === "" && !res.invalidBankStatement) {
              this.toggleChangeBank = 'open_tab';
            } else if (res.bankStatementProcessed && res.hasRequiredMonthsBankStatement === "true" && !res.invalidBankStatement) {
              this.submitBusiness();
            }
          } else {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
              [this.$mixpanelPayload.RESPONSE]: res,
            });
          }
          this.statusData = res;
          if (res.invalidBankStatement || (res.hasRequiredMonthsBankStatement === 'false' && res.processingType === 'manual')) {
            this.$router.push({
              name: 'Show Bank Statement',
              query: {
                bankStatementProcessed: res.bankStatementProcessed,
                hasRequiredMonthsBankStatement: res.hasRequiredMonthsBankStatement,
                processingType: res.processingType,
                invalidBankStatement: res.invalidBankStatement
              }
            });
          } else if (res.hasRequiredMonthsBankStatement === 'true' ||
              (res?.hasRequiredMonthsBankStatement === '' && res?.processingType === 'manual')) {
              this.$store.commit('SET_IS_BANK_STATEMENT_DOC_UPLOADED', true);
          }
          this.isSpinLoading = false;
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message
          });
          this.isSpinLoading = false;
        });
    },
    getBankStatementStatusRetry() {
      this.isSpinLoadingLoanOffer = true;
      let retryCount = 0;
      const maxRetries = 6;
      const retryInterval = 10000;
      const checkStatus = () => {
        this.$store
          .dispatch('bankStatementStatus', {
            applicationId: this.applicationId,
          })
          .then((res) => {
            if (res?.hasRequiredMonthsBankStatement === 'true') {
              this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                [this.$mixpanelPayload.RESPONSE]: res,
                [this.$mixpanelPayload.KEY_MESSAGE]: 're-try from the third party app',
              });
              this.isSpinLoadingLoanOffer = false;
              this.changeSiftCloseTab(res);
            } else {
              retryCount += 1;
              if (retryCount < maxRetries) {
                setTimeout(() => {
                  checkStatus();
                }, retryInterval);
              } else {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                  [this.$mixpanelPayload.RESPONSE]: res,
                  [this.$mixpanelPayload.KEY_MESSAGE]: 'Bank statement check after 6 retries.',
                });
                this.isSpinLoadingLoanOffer = false;
                this.changeSiftCloseTab(res);
              }
            }
          })
          .catch((err) => {
            retryCount += 1;
            console.error('Error checking bank statement:', err);
            if (retryCount < maxRetries) {
              setTimeout(() => {
                checkStatus();
              }, retryInterval);
            } else {
              this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                [this.$mixpanelPayload.RESPONSE]: err,
                [this.$mixpanelPayload.KEY_MESSAGE]: 'Bank statement check failed after 6 retries.',
              });
              this.isSpinLoadingLoanOffer = false;
              console.log('Bank statement check failed after 6 retries.');
            }
          });
      };
      checkStatus();
    },
    changeSiftCloseTab(res) {
      if (res.hasRequiredMonthsBankStatement === 'true') {
        this.isPanelBankStatementUnderReview = false;
        this.toggleChangeBank = 'close_tab';
        this.statusData = res;
        this.$store.commit('SET_IS_BANK_STATEMENT_DOC_UPLOADED', true);
        this.submitBusiness();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      } else {
        this.toggleChangeBank = 'shift_tab';
      }
    },
    CheckStatusOneMoney() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    slotBooked() {
      this.isSpinLoading = true;
      this.$store
      .dispatch('bookSlots', {
        applicationId: this.applicationId,
        rowData: {
          date: this.videoKycScheduledDateTime?.date,
          slotName: this.videoKycScheduledDateTime?.time
        }
      })
      .then((result) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SLOT_BOOK, {
          [this.$mixpanelPayload.RESPONSE]: result,
        });
        this.$moshaToast(result, { type: 'success', showIcon: 'true' });
        this.isSpinLoading = false;
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SLOT_BOOK, {
          [this.$mixpanelPayload.ERROR_REASON]: err.message,
        });
        this.isSpinLoading = false;
      });
    },
    handelDocumentSelect(val) {
      this.businessDocumentSelect = val;
      this.isPanelOpen = true;
    },
    getInstantVerification() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.isSpinLoading = true;
      this.$store
        .dispatch('createConsentOneMoney', {
        })
        .then((result) => {
          if (result?.status === "success") {
            window.microapps.openUrl({ url: result?.data?.webRedirectionUrl });
          }
          this.isSpinLoading = false;
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    getBankStatementStatusNextBtn() {
      this.isSpinLoadingLoanOffer = true;
      let retryCount = 0;
      const maxRetries = 6;
      const retryInterval = 10000;
      const checkStatus = () => {
        this.$store
          .dispatch('bankStatementStatus', {
            applicationId: this.applicationId,
          })
          .then((res) => {
            if (res?.hasRequiredMonthsBankStatement === 'true') {
              this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                [this.$mixpanelPayload.RESPONSE]: res,
                [this.$mixpanelPayload.KEY_MESSAGE]: 'next button click',
              });
              this.isSpinLoadingLoanOffer = false;
              this.updateBusinessInfoStatus();
            } else {
              retryCount += 1;
              if (retryCount < maxRetries) {
                setTimeout(() => {
                  checkStatus();
                }, retryInterval);
              } else {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                  [this.$mixpanelPayload.RESPONSE]: res,
                  [this.$mixpanelPayload.KEY_MESSAGE]: 'next btn after 6 retries.',
                });
                if (res.invalidBankStatement || (res.hasRequiredMonthsBankStatement === 'false' && res.processingType === 'manual')) {
                  this.$router.push({
                    name: 'Show Bank Statement',
                    query: {
                      bankStatementProcessed: res.bankStatementProcessed,
                      hasRequiredMonthsBankStatement: res.hasRequiredMonthsBankStatement,
                      processingType: res.processingType,
                      invalidBankStatement: res.invalidBankStatement
                    }
                  });
                } else if (res?.hasRequiredMonthsBankStatement === '' && res?.processingType === 'manual') {
                  this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MANUAL_POPUPS, {
                    [this.$mixpanelPayload.KEY_MESSAGE]: 'Bank statement review is in progress. on click of next btn',
                  });
                  this.isPanelBankStatementUnderReview = true;
                }
                this.isSpinLoadingLoanOffer = false;
                console.log('next btn not processed after 6 retries.');
              }
            }
          })
          .catch((err) => {
            retryCount += 1;
            console.error('Error checking bank statement:', err);
            if (retryCount < maxRetries) {
              setTimeout(() => {
                checkStatus();
              }, retryInterval);
            } else {
              this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BANK_STATEMENT_STATUS_API, {
                [this.$mixpanelPayload.RESPONSE]: err,
                [this.$mixpanelPayload.KEY_MESSAGE]: 'next btn failed after 6 retries.',
              });
              this.isSpinLoadingLoanOffer = false;
              console.log('next btn check failed after 6 retries.');
            }
          });
      };
      checkStatus();
    },
  },
};
</script>
<style lang="scss" scoped>
  .info-popup {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }
  .popup-dialog {
    color: black;
    position: absolute;
    top: 100%;
    left: -80px;
    background-color: white;
    padding: 10px;
    border-radius: 10px 6px 10px 10px;
    box-shadow: 0 3px 10px #00000014;
    z-index: 2;
    width: 12rem;
  }
  .popup-pointer {
    position: absolute;
    top: -10px; /* Position the pointer above the popup */
    left: 6%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent white transparent;
  }
  .info-popup:hover .popup-dialog {
    display: block;
  }
/* Add your CSS styles for the block and close button here */
.content {
  padding: 1px;
  user-select: none;
  position: relative;
}
.close-button {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: 16px;
  color: red;
}

</style>
